import UnexpectedError from './UnexpectedError';

export default UnexpectedError;
